<template>
  <div class="user-info">
    <el-card>
      <template #header>
        <div class="card-header">
          <el-button @click="$router.push('/dashboard')" type="primary" plain style="margin-right: 10px;">
            返回首页
          </el-button>
          <span>用户信息列表</span>
        </div>
      </template>
      
      <el-table :data="users" style="width: 100%" v-loading="loading">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="nickname" label="昵称" width="120" />
        <el-table-column prop="gender" label="性别" width="80">
          <template #default="scope">
            {{ scope.row.gender === 1 ? '男' : '女' }}
          </template>
        </el-table-column>
        <el-table-column prop="avatar" label="头像" width="100">
          <template #default="scope">
            <el-image 
              v-if="scope.row.avatar"
              :src="scope.row.avatar"
              :preview-src-list="[scope.row.avatar]"
              fit="cover"
              style="width: 40px; height: 40px; border-radius: 50%;"
            />
            <span v-else>无头像</span>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="描述" min-width="200" show-overflow-tooltip />
        <el-table-column prop="openid" label="OpenID" width="220" show-overflow-tooltip />
        <el-table-column prop="created_at" label="注册时间" width="180">
          <template #default="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column prop="updated_at" label="更新时间" width="180">
          <template #default="scope">
            {{ formatDate(scope.row.updated_at) }}
          </template>
        </el-table-column>
        <el-table-column prop="is_manually_modified" label="是否手动修改" width="100">
          <template #default="scope">
            {{ scope.row.is_manually_modified ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column prop="total_orders" label="总订单数" width="100" />
        <el-table-column prop="life_care_orders" label="生活照料订单" width="120" />
        <el-table-column prop="meal_orders" label="膳食服务订单" width="120" />
        <el-table-column prop="cleaning_orders" label="清洁服务订单" width="120" />
        <el-table-column prop="activity_orders" label="活动报名订单" width="120" />
        <el-table-column prop="custom_orders" label="个性委托订单" width="120" />
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import axios from 'axios'

export default {
  name: 'UserInfo',
  setup() {
    const users = ref([])
    const loading = ref(false)

    const fetchUsers = async () => {
      loading.value = true
      try {
        const response = await axios.get('/user_info.php')
        if (response.data.code === 0) {
          users.value = response.data.data
        } else {
          console.error('获取用户信息失败:', response.data.message)
        }
      } catch (error) {
        console.error('获取用户信息失败:', error)
      } finally {
        loading.value = false
      }
    }

    const formatDate = (dateString) => {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    }

    onMounted(() => {
      fetchUsers()
    })

    return {
      users,
      loading,
      formatDate
    }
  }
}
</script>

<style scoped>
.user-info {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-table {
  margin-top: 20px;
}

.el-image {
  cursor: pointer;
}
</style> 